import React from 'react';
import { motion } from 'framer-motion';
import { StageCardProps } from '../../types/judge';

/**
 * Dynamic card with stage lighting effects
 * A reusable card component with glassmorphism design and customizable glow colors
 */
const StageCard: React.FC<StageCardProps> = ({ 
  children, 
  className = "", 
  glowColor = "pink" 
}) => {
  const glowColors = {
    pink: "shadow-pink-500/15",
    purple: "shadow-purple-500/15",
    orange: "shadow-orange-500/10",
    green: "shadow-green-500/10",
    blue: "shadow-blue-500/10"
  };

  const hoverShadows = {
    pink: 'rgba(236, 72, 153, 0.25)',
    purple: 'rgba(168, 85, 247, 0.25)',
    orange: 'rgba(251, 146, 60, 0.2)',
    green: 'rgba(34, 197, 94, 0.2)',
    blue: 'rgba(59, 130, 246, 0.2)'
  };

  return (
    <div
      className={`relative bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl ${glowColors[glowColor]} ${className} hover:shadow-2xl transition-shadow duration-300`}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent rounded-2xl" />
      <div className="relative h-full">{children}</div>
    </div>
  );
};

export default StageCard;
